var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCctv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 508 508",
    style: {
      enableBackground: "new 0 0 508 508"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#0d87c5"
    },
    cx: 254,
    cy: 254,
    r: 254
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M427.3,305.3l-244.6-72.5c-0.7-0.2-1.1-0.9-0.9-1.6l25-84.4c0.2-0.7,0.9-1.1,1.6-0.9L453,218.4 c0.7,0.2,1.1,0.9,0.9,1.6l-25,84.4C428.7,305.1,428,305.5,427.3,305.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M395.4,317.2L89.5,226.6c-1.9-0.5-2.9-2.5-2.4-4.3L117.7,119c0.5-1.9,2.5-2.9,4.3-2.4l306,90.7 c1.9,0.5,2.9,2.5,2.4,4.3l-30.6,103.2C399.2,316.7,397.2,317.8,395.4,317.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M275.8,439H199c-0.9,0-1.7-0.8-1.7-1.7v-76.8c0-0.9,0.8-1.7,1.7-1.7h76.8c0.9,0,1.7,0.8,1.7,1.7 v76.8C277.5,438.2,276.7,439,275.8,439z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M355,264.8L89.8,186.2c-6.9-2.1-10.9-9.4-8.8-16.3l22.6-76.2c2.1-6.9,9.4-10.9,16.3-8.8l322.9,95.7 c9.5,2.8,13.3,14.2,7.4,22.2l-29.5,40C405.6,263.2,379.4,272,355,264.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CED5E0"
    },
    cx: 237.4,
    cy: 398.9,
    r: 23.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CED5E0"
    },
    cx: 266.2,
    cy: 377.1,
    r: 5.1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CED5E0"
    },
    cx: 266.2,
    cy: 433.9,
    r: 5.1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CED5E0"
    },
    cx: 207.5,
    cy: 370.9,
    r: 5.1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CED5E0"
    },
    cx: 207.5,
    cy: 427.7,
    r: 5.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#324A5E"
    },
    points: "162,257.2 125.9,359.9 144.4,366.4 182.7,257.2  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M235.1,388.2l-95.5-33.5l-6.3,18l95.5,33.5c5,1.7,10.4-0.9,12.1-5.8l0,0 C242.7,395.3,240.1,389.9,235.1,388.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M153.4,387.4l-47.7-16.7c-0.6-0.2-0.9-0.9-0.7-1.5l10.4-29.6c0.2-0.6,0.9-0.9,1.5-0.7l47.7,16.7 c0.6,0.2,0.9,0.9,0.7,1.5l-10.4,29.6C154.6,387.3,154,387.6,153.4,387.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 172.8,
    cy: 253,
    r: 33.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E6E9EE"
    },
    cx: 172.8,
    cy: 253,
    r: 18.9
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCctv);
export default __webpack_public_path__ + "static/media/cctv.fd6d2b10a934a2cda39c7e17ca49abae.svg";
export { ForwardRef as ReactComponent };